module.exports = __webpack_public_path__ + "static/fonts/Poppins-Regular.093ee89b.ttf";